import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PresentationProductPage } from './presentation-product';

@NgModule({
  declarations: [
    PresentationProductPage,
  ],
  imports: [
    IonicPageModule.forChild(PresentationProductPage),
  ],
})
export class PresentationProductPageModule {}



// WEBPACK FOOTER //
// ./src/pages/presentation-product/presentation-product.module.ts